import type {CoCoachFields} from './types';

import {FULL_PORTION} from './constants';

export const fillPortionsToFull = <T extends CoCoachFields>(coaches: T[]) => {
  const result = coaches.slice();

  const portions = result.map(coach => coach.portion);
  const sum = portions.reduce((a, b) => a + b, 0);
  const diff = FULL_PORTION - sum;

  if (diff > 0) {
    const notZeroPortionIndex = result.findIndex(coach => coach.portion !== 0);

    if (notZeroPortionIndex >= 0) {
      result[notZeroPortionIndex]!.portion += diff;
    }
  }

  return result;
};
